<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Rebuild Contact - {{ campaignDescription.campaign_name }}</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>





            <vs-row vs-w="12" class="mb-2">
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <span class="font-semibold"> Status : </span> {{contactDescription.contact_status}}
            
          </vs-col>
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <span class="font-semibold"> Sub Status : </span> {{contactDescription.contact_sub_status}}
            
          </vs-col>
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <span class="font-semibold"> Status Notes : </span> <span v-text="contactDescription.contact_status_notes"></span> 
            
          </vs-col>
        
        
        
        
        
        </vs-row>

      <form>


          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Select Account:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <AccountAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchAccount"
                :searchOn="'company_or_registration_no'"
                @event-name="handleChildEvent"
              ></AccountAutocomplete> -->
              {{ contactDescription.company_name }}
            </div>

            <span class="text-danger text-sm mt-2 ml-16">{{
              account_validation
            }}</span>
          </div>
          <!-- if satellite office is empty then contant lies on resitered office -->
          <div class="vx-row mb-6" v-if="showAddressField">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                name="satellite_address"
                label="satellite_address"
                :options="satellite_offices"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.satellite_address"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="title"
                v-model="contactDescription.title"
                v-validate="'required'"
                data-vv-as="Title"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('title')"
              >{{ errors.first("title") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Forename:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="forename"
                data-vv-as="Forename"
                v-validate="'required'"
                v-model="contactDescription.forename"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('forename')"
              >{{ errors.first("forename") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="surname"
                data-vv-as="Surname"
                v-validate="'required'"
                v-model="contactDescription.surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Job Title:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full" >
              <vs-input v-validate="'required'" name="job_title"  data-vv-as="Job Title" class="w-full" v-model="contactDescription.job_title" />
              
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('job_title')"
              >{{ errors.first("job_title") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Seniority:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                name="seniority"
                data-vv-as="Seniority"
                label="seniority"
                :options="contacts.seniorities"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.seniority"
              />
            </div>
           
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                data-vv-as="Role"
                name="role"
                label="role"
                :options="contacts.roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.role"
              />
            </div>
           
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sub Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                data-vv-as="Sub Role"
                name="sub_role"
                label="sub_role"
                :options="contacts.sub_roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contactDescription.sub_role"
              />
            </div>
          
          </div>
          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Email                  

              </h5>



            </div>
            <div class="vx-col sm:w-1/5 w-full">

              <vs-button color="primary" @click="addEmail" type="filled"
                >Add</vs-button>
          </div>
          </div>
         

            <template 
            v-for="(email, index) in contactDescription.emails"
          >



        
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="email.email"
                data-vv-as="Email"
              />
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('email')"
                >{{ errors.first("email") }}</span
              >
            </div>
         

            <div class="vx-col sm:w-1/5 w-full">

              <vs-icon
              style="cursor:pointer;"
                  @click="validateEmailZeroBounce(email.email)"
                  color="success"
                  icon="checkmark"
                ></vs-icon>


              <!-- <vs-radio
              v-model="email.primary"
              :vs-value="email.primary"
              class="mr-4"
              vs-name="primary_email"
            ></vs-radio
            > -->


            <vs-icon
            class="removeButton"
            @click="removeSelectedEmail(email)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>

           
            </template>
            {{ email_validate_status }}
        
          <vs-divider class="m-5" />


          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Social Media Pages    
              </h5>


            </div>
            <div class="vx-col sm:w-1/5 w-full">

              <vs-button color="primary" @click="addSocialMedia" type="filled"
                >Add</vs-button>
          </div>
          </div>
         

            <template
            v-for="(social_media, index) in contactDescription.social_medias"
          >

        
          <div class="vx-row">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="social_media"
                v-model="social_media.social_media"
                data-vv-as="Social Media"
              />
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('social_media')"
                >{{ errors.first("social_media") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-textarea
              v-model="social_media.summary"
            />

         

            
            
            
            </div>

            <div class="vx-col sm:w-1/5 w-full">

              <!-- <vs-radio
              v-model="social_media.primary"
              :vs-value="social_media.primary"
              class="mr-4"
              vs-name="primary_social_media"
            ></vs-radio
            > -->


            <vs-icon
            class="removeButton"
            @click="removeSelectedSocialMedia(social_media)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>

           
            </template>
           
        
          <vs-divider class="m-5" />

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">DDI
              </h5>


            </div>
            <div class="vx-col sm:w-1/5 w-full">

              <vs-button color="primary" @click="addDDI" type="filled"
                >Add</vs-button>
          </div>
          </div>
         

            <template
            v-for="(ddi, index) in contactDescription.ddis"
          >

        
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">


              <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="ddi.ddi_phone_code" />
            
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('ddi')"
                >{{ errors.first("ddi") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
              class="w-full"
              name="ddi"
              v-model="ddi.ddi"
              data-vv-as="DDI"
            />

         

            
            
            
            </div>

            <div class="vx-col sm:w-1/5 w-full">

              <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->


            <vs-icon
            class="removeButton"
            @click="removeSelectedDDI(ddi)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>

           
            </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Mobile
              </h5>
          
          
            </div>
            <div class="vx-col sm:w-1/5 w-full">
          
              <vs-button color="primary" @click="addMobile" type="filled"
                >Add</vs-button>
          </div>
          </div>
          
          
            <template
            v-for="(mobile, index) in contactDescription.mobiles"
          >
          
          
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">
          
          
              <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="mobile.mobile_phone_code" />
            
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('mobile')"
                >{{ errors.first("mobile") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
              class="w-full"
              name="mobile"
              v-model="mobile.mobile"
              data-vv-as="Mobile"
            />
          
          
          
            
            
            
            </div>
          
            <div class="vx-col sm:w-1/5 w-full">
              
          
              <!-- <vs-radio
              v-model="mobile.primary"
              :vs-value="mobile.primary"
              class="mr-4"
              vs-name="primary_mobile"
            ></vs-radio
            > -->
          
          
            <vs-icon
            class="removeButton"
            @click="removeSelectedMobile(mobile)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>
          
           
            </template>
            <vs-divider class="m-10" />

      
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Update</vs-button
              >
            </div>
          </div>

                </form>

                 <vs-divider class="m-10" />

      <div class="mb-10">


        <form data-vv-scope="UpdateStatus">

        <vs-row>

    <vs-col vs-type="flex" vs-w="4">
            </vs-col>
            <vs-col vs-type="flex" vs-w="4">
              <div class="vx-row w-full">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Status:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    name="UpdateStatus.status"
                    label="status"
                    :options="all_sd_status"
                    v-model="selected_status"
                    v-validate="'required'"
                    data-vv-as="Status"
                  />
                </div>
              </div>
            </vs-col>
                <vs-col vs-type="flex" vs-w="4">
         
            </vs-col>

          
          </vs-row>
          <vs-row>

             <vs-col vs-type="flex" vs-w="4" >
          
            </vs-col>


      <vs-col vs-type="flex" vs-w="4" v-if="contact_sub_statuses.length > 0">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Sub Status:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">

                    <template v-for="sub_status in contact_sub_statuses">
                        <input 
                          v-validate="'required'"
                          data-vv-as="Sub Status"
                          name="UpdateStatus.sub_status"
                          v-model="selected_contact_sub_status"
                          :value="sub_status"
                          type="checkbox">
                         <span class="ml-2"> {{ sub_status.sub_status }} </span> 


                       </br>
               </template>



               
              
                </div>
              </div>
            </vs-col>
                <vs-col vs-type="flex" vs-w="4" >
          
            </vs-col>

          
          </vs-row>


            <vs-row>

             <vs-col vs-type="flex" vs-w="4" >
          
            </vs-col>

      <vs-col vs-type="flex" vs-w="4">
             <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Notes:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    v-validate="'required'"
                    class="w-full"
                    name="selected_status_notes"
                    v-model="selected_status_notes"
                    data-vv-as="Status Notes"
                  />

                  <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('UpdateStatus.selected_status_notes')">{{
              errors.first("UpdateStatus.selected_status_notes") }}</span>
  
                  

                  <vs-button :disabled="selected_status == null || selected_status_notes == null || selected_status_notes.trim() == ''" class="mt-5 build-complete" @click.prevent="contactRebuildComplete"
                    >Contact Rebuild Complete </vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/4 w-full"></div>
              </div>
            </vs-col>
                <vs-col vs-type="flex" vs-w="4" >
          
            </vs-col>
            

          
          </vs-row>


</form>

          
      </div>

          
        </vx-card>

      






       
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import vSelect from "vue-select";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
export default {
  data() {
    return {
            campaignDescription: [],

      temp_table_id: null,
      selected_status_notes: null,
          user_role_id: null,
      contact_sub_statuses: [],
          selected_contact_sub_status: [],

          please_choose_status: null,
          selected_status: null,

          all_sd_status: [],
      email_validate_status: null,

      all_phone_codes:[],
      previous_account_id:0,
      editContactpopupActive: false,
      viewContactpopupActive: false,
      emailExistspopupActive: false,
      existsEmailseditContacts: [],
      edit_primary_email: null,
      viewContactDescription:{},
      editContactDescription: {},
      showEditAddressField: false,
      edit_satellite_offices: [],
      edit_account_validation: null,
      edit_accounts: [],
      companySearchComponentKey: 0,
      abilities: null,
      editContacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
                primary_ddi: null,

        edit_primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
                ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
                ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      editContactShowPopup: false,
      records: [],
      new_added_email: "fake@example.com",
      dataSource: {},
      abilities: null,
      columnDefs: [
        {
          headerName: "Actions",
          field: "transactions",
          cellRenderer: "CellRendererActions",
          suppressHeaderMenuButton: true,
          pinned: true,
          width: 120
        },
        {
          headerName: "Company",
          field: "company_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Address",
          field: "address",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Title",
          field: "title",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "ForeName",
          field: "forename",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Surname",
          field: "surname",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "DDI",
          field: "ddi",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Job Title",
          field: "job_title",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Email",
          field: "email",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Mobile",
          field: "mobile",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
    headerName: "DDI",
    field: "ddi",
    filter: "agTextColumnFilter",
    filterParams: {
      buttons: ["apply", "reset"],
      maxNumConditions: 4
    }
  },
        {
          headerName: "Seniority",
          field: "seniority_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Social Media",
          field: "social_media",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Role",
          field: "role_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Sub Role",
          field: "sub_role",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      editContactpopupActive: false,
      viewContactpopupActive: false,
      emailExistspopupActive: false,
      existsEmailsContacts: [],
      primary_email: null,
      contactDescription: {},
      showAddressField: false,
      satellite_offices: [],
      account_validation: null,
      accounts: [],
      companySearchComponentKey: 0,
      abilities: null,
      contacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
                primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
                ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
                ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      }
    };
  },
  components: {
    "v-select": vSelect,
    AccountAutocomplete,
    DataGrid
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });



     let userInfo = JSON.parse(localStorage.getItem('userInfo'))



     this.user_id = userInfo['uid']


          this.user_role_id = userInfo['roleId']

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }



    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

     if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }


  },
  watch: {
         selected_status (val) {
      if (val) {
        console.log("STATUS CHANGED" , this.user_role_id)
        this.fetchSDSubStatusByStatusIDAndRoleID(val.id , this.user_role_id)
      }
    },
    "contactDescription.role"(val) {
      if (val) {
        this.contacts.sub_roles = [];
        if (val.id !== undefined) {
          this.getSubRole(val.id);
        }
      }
    },
    "editContactDescription.role"(val) {
      if (val) {
        this.editContacts.sub_roles = [];
        if (val.id !== undefined) {
          this.getEditSubRole(val.id);
        }
      }
    }
  },
  beforeMount() {
  },
  mounted() {
    this.init();


    this.getCampaignDescription()

    this.getSeniority();
    this.getRoles();
    this.getEditSeniority();
    this.getEditRoles();
    this.getAllPhoneCodes()
              this.fetchAllSDStatus()
              

    // this.getVerticals();
  },
  methods: {
        getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
     contactRebuildComplete () {
          let self = this
      self.contactDescription.user_id = this.user_id
      self.contactDescription.campaign_id = this.$route.params.campaignId
      self.contactDescription.id = this.temp_table_id
      self.contactDescription.contact_id = this.$route.params.contactId
      self.contactDescription.new_contact_status = this.selected_status
      self.contactDescription.new_contact_sub_status = this.selected_contact_sub_status
      self.contactDescription.new_status_notes = this.selected_status_notes
            self.contactDescription.table_id = this.$route.params.tableId




      console.log("CONTACT DESCR" , this.contactDescription)

            this.$store
        .dispatch(
          'contactsManagement/contactRebuildComplete',
          self.contactDescription
        )
        .then(res => {

        if (res.data.status == 'success') {
           

            this.$router.push(
              '/data_build/data_administration_contact_rebuild/' +
                this.$route.params.campaignId
            )
          }

        
        })
        .catch(err => {
          console.log(err)
        })
     
    },
    fetchSDSubStatusByStatusIDAndRoleID(status_id,role_id) {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatusByStatusIDAndRoleID", {
          status_id: status_id,
          role_id: role_id
        })
        .then(res => {
          let result = JSON.parse(res.data);


          self.contact_sub_statuses = []

          result.forEach(function (ele) {
           if (ele.level == 'contact'){
                self.contact_sub_statuses.push(ele)
           }
          });



  



        })
        .catch(err => {
          console.error(err);
        });
    },
        fetchAllSDStatus () {
      this.$store
        .dispatch('campaignsManagement/fetchAllSDStatus')
        .then(res => {
          let result = res.data

           result = result.filter(function(ele) {
              return ele.status != 'rebuild';
           })


          this.all_sd_status = result

           

        })
        .catch(err => {
          console.error(err)
        })
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
  
    searchEditAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    editSubmitForm() {
      // console.log(this.editContactDescription)
      // return false

      let self = this;
      if (this.editContactDescription.edit_primary_email) {
        this.editContactDescription.primary_email = this.editContactDescription.edit_primary_email;
      }
      // if (
      //   self.edit_accounts.length === 0 &&
      //   self.editContactDescription.company_name == null
      // ) {
      //   self.edit_account_validation = "The Account field is required";
      //   return false;
      // } else {
      //   if (self.edit_accounts.length != 0) {
      //     self.editContactDescription.account_id = self.edit_accounts[0].id;
      //   }
      //   self.updateEditContact();
      // }

      this.$validator.validateAll("popup-edit-form").then(result => {
        // console.log(this.editContactDescription.company_name);
        if (result) {
          if (
            self.edit_accounts.length === 0 &&
            self.editContactDescription.company_name == null
          ) {
            self.edit_account_validation = "The Account field is required";
            return false;
          } else {
            if (self.edit_accounts.length != 0) {
              self.editContactDescription.account_id = self.edit_accounts[0].id;
            }
            self.updateEditContact();
          }

          // if form have no errors
        } else {
          return false;
        }
      });
    },
    getEditSatelliteOffices(account_id) {
      let self = this;
      self.$store
        .dispatch("accountsManagement/getSatelliteOffices", account_id)
        .then(res => {
          // console.log("sdfdfsdf", res.data);

          self.edit_satellite_offices = res.data;
          if (self.edit_satellite_offices.length != 0) {
            self.showEditAddressField = true;
            self.edit_satellite_offices.forEach(function(ele) {
              ele.satellite_address =
                ele.address_1 + "," + ele.city + "," + ele.county;
              return ele;
            });
          } else {
            self.showEditAddressField = false;
          }
          // console.log(self.edit_satellite_offices);
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateEditContact() {
      if (Array.isArray(this.editContactDescription.role)) {
        this.editContactDescription.role = this.editContactDescription.role[0];
      }

      if (Array.isArray(this.editContactDescription.sub_role)) {
        this.editContactDescription.sub_role = this.editContactDescription.sub_role[0];
      }

      if (Array.isArray(this.editContactDescription.seniority)) {
        this.editContactDescription.seniority = this.editContactDescription.seniority[0];
      }

      // if (Array.isArray(this.editContactDescription.job_title)) {
      //   this.editContactDescription.job_title = this.editContactDescription.job_title[0];
      // }

      //       console.log("sfsdfsdf" , this.editContactDescription)
      // return false

      if (Object.keys(this.editContacts.satellite_address).length != 0) {
        this.editContactDescription.satellite_office_id = this.editContacts.satellite_address.uuid;
      } else {
        this.editContactDescription.satellite_office_id = null;
      }
      this.$store
        .dispatch(
          "contactsManagement/updateContact",
          this.editContactDescription
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$refs.EditEmailExistsInDb.gridApi.refreshServerSide({purge : true});

            this.editContactShowPopup = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    
    viewContactDetails(contactId) {
      this.$store
        .dispatch("contactsManagement/fetchContact", contactId)
        .then(res => {
          this.viewContactDescription = res.data;
          this.viewContactpopupActive = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    viewContactpopup(contact) {
      this.viewContactDetails(contact.contact_id);
    },
    closeThisWindow() {
      let self = this;
      self.viewContactpopupActive = false;
    },
    removeSelectedSocialMedia(social_media) {
      this.contactDescription.social_medias = this.contactDescription.social_medias.filter(
        item => {
          return item != social_media;
        }
      );
    },
    removeSelectedEmail(email) {
      this.contactDescription.emails = this.contactDescription.emails.filter(
        item => {
          return item != email;
        }
      );
    },
    removeSelectedMobile(mobile) {
      this.contactDescription.mobiles = this.contactDescription.mobiles.filter(
        item => {
          return item != mobile;
        }
      );
    },
    removeSelectedDDI(ddi) {
    this.contactDescription.ddis = this.contactDescription.ddis.filter(
      item => {
        return item != ddi;
      }
    );
  },
    handleChildEvent() {
      this.satellite_offices = [];
      this.accounts = moduleAccountsManagement.state.accounts.datas;
      this.contactDescription.account_id = this.accounts[0].id
      this.getSatelliteOffices(this.accounts[0].id);
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getEditSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.editContacts.seniorities = res.data;
          // console.log(this.editContacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getEditRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.editContacts.roles = res.data;
          // console.log("Roles", this.editContacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getEditSubRole(role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.editContactDescription.sub_role = null

      // }
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.editContacts.sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.contacts.seniorities = res.data;
          // console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.contacts.roles = res.data;
          // console.log("Roles", this.contacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSubRole(role_id) {
      // alert(role_id)
      // if(!role_id){
      // this.contactDescription.sub_role = null

      // }
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.contacts.sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function() {
                  this.$router.push({ path: "/data_build/data_administration_contact_rebuild/" + this.$route.params.campaignId });
    },
    removeSelectedPhone(selected) {
      this.contacts.joinedPhoneAndTypes = this.contacts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    // addEmail() {
    //   console.log("New Email" , this.contactDescription.email)
    //   if (
    //     this.contactDescription.email &&
    //     !this.contactDescription.emails.includes(this.contactDescription.email)
    //   )
    //     this.contactDescription.emails.push({
    //       email: this.contactDescription.email
    //     });
    //   this.contactDescription.email = null;

    //   console.log("Emails", this.contactDescription.emails);
    // },
    validateEmailZeroBounce(email){
      let self = this

        self.$vs.loading();

        this.$store
        .dispatch("contactsManagement/validateEmailZeroBounce", email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close();

         console.log(res)
        })
        .catch(err => {
          console.error(err);
        });


     

    },
    addSocialMedia() {
      this.contactDescription.social_medias.push({
          social_media: null,
          summary: null,
          primary: false

        });
    },
    addEmail() {
  this.contactDescription.emails.push({
      email: null,
      primary: false

    });
},
addDDI() {
  this.contactDescription.ddis.push({
      ddi: null,
      ddi_phone_code: null,
      primary: false

    });
},
    addMobile() {
      this.contactDescription.mobiles.push({
          mobile: null,
          mobile_phone_code: null,
          primary: false

        });
    },
    submitForm() {
      // console.log(this.contactDescription)
      // return false

      let self = this;
      self.updateContact();
    },
    getSatelliteOffices(account_id) {
      let self = this;
      self.$store
        .dispatch("accountsManagement/getSatelliteOffices", account_id)
        .then(res => {
          // console.log("sdfdfsdf", res.data);

          self.satellite_offices = res.data;
          if (self.satellite_offices.length != 0) {
            self.showAddressField = true;
            self.satellite_offices.forEach(function(ele) {
              ele.satellite_address =
                ele.address_1 + "," + ele.city + "," + ele.county;
              return ele;
            });
          } else {
            self.showAddressField = false;
          }
          // console.log(self.satellite_offices);
        })
        .catch(err => {
          console.error(err);
        });
    },
    init() {
      let self = this;
      let data = {}
      data.account_id = this.$route.params.accountId
      data.contact_id = this.$route.params.contactId
      self.$store
        .dispatch("contactsManagement/fetchContactForRebuild", data)
        .then(res => {
          self.contactDescription = res.data;
          self.temp_table_id = res.data.table_id;



          
          self.previous_account_id =
            self.contactDescription.account_id;
          // console.log(
          //   "Previous Account Contact Description",
          //   self.contactDescription
          // );

          if (self.contactDescription.selected_satellite_office) {
            self.contactDescription.satellite_address =
              self.contactDescription.selected_satellite_office;
            self.getSatelliteOffices(self.contactDescription.account_id);
          }

          if (self.contactDescription.role) {
            self.contactDescription.role.forEach(function(ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.contactDescription.sub_role) {
            self.contactDescription.sub_role.forEach(function(ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.contactDescription.seniority) {
            self.contactDescription.seniority.forEach(function(ele) {
              ele.id = ele.uuid;
              return ele;
            });
          }

          if (self.contactDescription.emails) {
            self.contactDescription.emails.forEach(function(ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_email = ele.email;
              }
              return ele;
            });
          }

          if (self.contactDescription.social_medias) {
            self.contactDescription.social_medias.forEach(function(ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_social_media = ele.social_media;
              }
              return ele;
            });
          }

          if (self.contactDescription.mobiles) {
            self.contactDescription.mobiles.forEach(function(ele) {
              if (ele.primary == true) {
                self.contactDescription.primary_mobile = ele.mobile;
              }
              return ele;
            });
          }

          if (self.contactDescription.ddis) {
    self.contactDescription.ddis.forEach(function(ele) {
      if (ele.primary == true) {
        self.contactDescription.primary_ddi = ele.ddi;
      }
      return ele;
    });
  }

          if (self.contactDescription.job_title) {
            self.contactDescription.job_title =
              self.contactDescription.job_title[0]["job_title"];
          }

          self.getSubRole(self.contactDescription.role && self.contactDescription.role[0] && self.contactDescription.role[0].id)


          // this.contactDescription.webShow = this.contactDescription.web.slice(
          //   0,
          //   this.website_show_no
          // );
          // this.contactDescription.linkedinShow = this.contactDescription.linkedin.slice(
          //   0,
          //   this.linkedin_show_no
          // );
          // this.contactDescription.phone = this.contactDescription.phone.slice(
          //   0,
          //   this.telephone_show_no
          // );
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateContact() {
      if (Array.isArray(this.contactDescription.role)) {
        this.contactDescription.role = this.contactDescription.role[0];
      }

      if (Array.isArray(this.contactDescription.sub_role)) {
        this.contactDescription.sub_role = this.contactDescription.sub_role[0];
      }

      if (Array.isArray(this.contactDescription.seniority)) {
        this.contactDescription.seniority = this.contactDescription.seniority[0];
      }

      // if (Array.isArray(this.contactDescription.job_title)) {
      //   this.contactDescription.job_title = this.contactDescription.job_title[0];
      // }

      //       console.log("sfsdfsdf" , this.contactDescription)
      // return false

      if (Object.keys(this.contacts.satellite_address).length != 0) {
        this.contactDescription.satellite_office_id = this.contacts.satellite_address.uuid;
      } else {
        this.contactDescription.satellite_office_id = null;
      }

      this.contactDescription.previous_account_id = this.previous_account_id
      this.contactDescription.uuid = this.$route.params.contactId


      this.$store
        .dispatch("contactsManagement/updateRebuildContact", this.contactDescription)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Contact Rebuilt",
              text: "The contact was rebuilt successfully"
            });
                        this.$router.go(0);

          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.searchbox {
  width: 582px;
}
</style>